import { Component, Input, OnInit } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { FormInputComponent, IFormInputViewModel } from 'src/app/forms/form-input/form-input.component';
import { FormOkCancelComponent, IFormOkCancelViewModel } from 'src/app/forms/form-ok-cancel/form-ok-cancel.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  vm$: Observable<IViewModel>;

  /**
   * 
   */
  constructor(private authService: AuthService) { }

  /**
   * 
   * @param vm 
   */
  private formReset(vm: IViewModel) {
    vm.loginFormVm = undefined;
    vm.forgotPasswordFormVm = undefined;
    vm.registerFormVm = undefined;
  }

  /**
   * 
   * @param vm 
   */
  cancelClicked(vm: IViewModel) {
    this.formReset(vm);

    vm.loginFormVm = this.loginFormVm();
  }

  //#region register

  /**
   * 
   * @param vm 
   */
  async registerClicked(vm: IViewModel) {
    const ret = await FormOkCancelComponent.processOkAsync(vm.registerFormVm.okCancelVm, 'Registering...',
      () => this.authService.register(vm.registerFormVm.data.email, vm.registerFormVm.data.password, vm.registerFormVm.data.displayName));
  }

  /**
   * 
   * @param vm 
   */
  registerTextChanged(vm: IViewModel) {
    const valids = [
      vm.registerFormVm.displayName.validate(vm.registerFormVm.displayName).length == 0,
      vm.registerFormVm.email.validate(vm.registerFormVm.email).length == 0,
      vm.registerFormVm.password.validate(vm.registerFormVm.password).length == 0,
      vm.registerFormVm.password2.validate(vm.registerFormVm.password2).length == 0,
      vm.registerFormVm.data.password === vm.registerFormVm.data.password2
    ];
    vm.registerFormVm.okCancelVm.isValid = valids.filter(v => !v).length == 0;
  }

  /**
   * 
   * @returns 
   */
  private registerFormVm(): IRegisterFormViewModel {
    const data = { displayName: '', email: '', password: '', password2: '' };
    const ret: IRegisterFormViewModel = {
      title: 'Register',
      data: data,

      displayName: FormInputComponent.viewModel(data, 'displayName', { isRequired: true, title: 'Display Name' }),
      email: FormInputComponent.viewModel(data, 'email', { isRequired: true, title: 'Email', type: 'email' }),
      password: FormInputComponent.viewModel(data, 'password', { isRequired: true, title: 'Password', type: 'password' }),
      password2: FormInputComponent.viewModel(data, 'password2', {
        isRequired: true, title: 'Password', type: 'password',
        changeValidator: (v: string) => data.password != data.password2 ? 'Passwords must match' : undefined
      }),

      okCancelVm: FormOkCancelComponent.okCancelVm({ okText: 'Register' })
    };
    return ret;
  }

  //#endregion register

  //#region login

  /**
   * 
   * @param vm 
   * @param code 
   */
  loginActionClicked(vm: IViewModel, code: string) {
    this.formReset(vm);

    if (code == 'register')
      vm.registerFormVm = this.registerFormVm();
    else if (code == 'forgot-password')
      vm.forgotPasswordFormVm = this.forgotPasswordFormVm();
  }

  /**
   * 
   * @returns 
   */
  private loginFormVm(): ILoginViewFormModel {
    const data = { email: '', password: '' };
    const ret: ILoginViewFormModel = {
      title: 'Login',
      actions: [{ code: 'register', name: 'Register' }, { code: 'forgot-password', name: 'Forgot Password ' }],
      data: data,
      email: FormInputComponent.viewModel(data, 'email', { isRequired: true, title: 'Email', type: 'email' }),
      password: FormInputComponent.viewModel(data, 'password', { isRequired: true, title: 'Password', type: 'password' }),

      okCancelVm: FormOkCancelComponent.okCancelVm({ okText: 'Login', cancelText: '' })
    };
    return ret;
  }

  /**
   * 
   * @param vm 
   */
  async loginClicked(vm: IViewModel) {
    const ret = await FormOkCancelComponent.processOkAsync(vm.loginFormVm.okCancelVm, 'Authenticating...',
      () => this.authService.signIn(vm.loginFormVm.data.email, vm.loginFormVm.data.password));
  }

  /**
   * 
   * @param vm 
   */
  loginTextChanged(vm: IViewModel) {
    const valids = [
      vm.loginFormVm.email.validate(vm.loginFormVm.email).length == 0,
      vm.loginFormVm.email.validate(vm.loginFormVm.password).length == 0
    ];
    vm.loginFormVm.okCancelVm.isValid = valids.filter(v => !v).length == 0;
  }

  //#endregion login

  //#region forgot password

  /**
   * 
   * @returns 
   */
  private forgotPasswordFormVm(): IForgotPasswordFormViewModel {
    const data = { email: '' };

    const ret: IForgotPasswordFormViewModel = {
      title: 'Forgot Password',
      data: data,
      email: FormInputComponent.viewModel(data, 'email', { isRequired: true, title: 'Email', type: 'email' }),

      okCancelVm: FormOkCancelComponent.okCancelVm({ okText: 'Submit' })

    };
    return ret;
  }

  /**
   * 
   * @param vm 
   */
  async forgotPasswordClicked(vm: IViewModel) {
    const ret = await FormOkCancelComponent.processOkAsync(vm.forgotPasswordFormVm.okCancelVm, 'Submitting...',
      () => this.authService.resetPassword(vm.forgotPasswordFormVm.data.email));
    this.cancelClicked(vm);
  }

  /**
   * 
   * @param vm 
   */
   forgotPasswordTextChanged(vm: IViewModel) {
    const valids = [
      vm.forgotPasswordFormVm.email.validate(vm.forgotPasswordFormVm.email).length == 0,
    ];
    vm.forgotPasswordFormVm.okCancelVm.isValid = valids.filter(v => !v).length == 0;
  }  

  //#endregion forgot password

  /**
   * 
   */
  ngOnInit(): void {
    this.vm$ = of({}).pipe(
      map(ctx => {
        const ret: IViewModel = {
          loginFormVm: this.loginFormVm()
        };
        return ret;
      })
    );

  }

}

/**
 * 
 */
interface IViewModel {
  loginFormVm?: ILoginViewFormModel;
  registerFormVm?: IRegisterFormViewModel;
  forgotPasswordFormVm?: IForgotPasswordFormViewModel;
}

/**
 * 
 */
interface ILoginViewFormModel {
  data: { email: string, password: string };

  title: string;
  actions: { code: string, name: string }[];

  email: IFormInputViewModel;
  password: IFormInputViewModel;

  okCancelVm: IFormOkCancelViewModel;
}

/**
 * 
 */
interface IRegisterFormViewModel {
  data: { displayName: string, email: string, password: string, password2: string };

  title: string;

  displayName: IFormInputViewModel;

  email: IFormInputViewModel;
  password: IFormInputViewModel;
  password2: IFormInputViewModel;

  okCancelVm: IFormOkCancelViewModel;
}

/**
 * 
 */
interface IForgotPasswordFormViewModel {
  data: { email: string };

  title: string;

  email: IFormInputViewModel;

  okCancelVm: IFormOkCancelViewModel;
}